import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { LocalMenuGroupRouteNames, LocalMenuGroupRoutePathNames } from '../../../../enums';

const Component = () => import('./LocalBrandMenuWorksImport.vue');

export default {
  path: buildChildURL(
    LocalMenuGroupRoutePathNames.MENUWORKS,
    LocalMenuGroupRoutePathNames.MENUWORKS_UNIT_ID,
  ),
  name: LocalMenuGroupRouteNames.BRAND_MENUWORKS_IMPORT,
  component: Component,
} as RouteRecordRaw;
